<template lang="pug">
  .profile-page-form
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Общая информация
      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal(
            :class="{'form-elem_error':fieldsErrors.campName.value}"
            )
              .form-elem__title Название
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.campName"
                @input="resetError('campName')"
                )
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal(
            :class="{'form-elem_error':fieldsErrors.campCapacity.value}"
            )
              .form-elem__title Вместимость
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.campCapacity"
                @input="resetError('campCapacity')"
                ref="campCapacity"
                )
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Регион
              .form-elem__body
                simple-select-form(
                :list-data="campRegionsListData"
                :default-value="fields.campRegion"
                @onChangeDefaultValue="changeSelectValue"
                type="campRegion"
                :specificChoice="true"
                )
          .form__elem(
            v-if="fields.campRegion === 'Татарстан'"
          )
            .form-elem.form-elem_horizontal
              .form-elem__title Район
              .form-elem__body
                simple-select-form(
                :list-data="campAreasListData"
                :default-value="fields.campArea"
                @onChangeDefaultValue="changeSelectValue"
                type="campArea"
                :specificChoice="true"
                )
          .form__elem
            .form-elem.form-elem_horizontal(
            :class="{'form-elem_error':fieldsErrors.campType.value}"
            )
              .form-elem__title Тип
              .form-elem__body
                simple-select-form(
                :list-data="campTypesListData"
                :default-value="fields.campType"
                @onChangeDefaultValue="changeSelectValue"
                type="campType"
                :specificChoice="true"
                )
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal(
            :class="{'form-elem_error':fieldsErrors.campGeoLat.value}"
            )
              .form-elem__title Широта
              .form-elem__body
                input.input.input_full(
                v-model="fields.campGeoLat"
                @input="resetError('campGeoLat')"
                ref="campGeoLat"
                )
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal(
            :class="{'form-elem_error':fieldsErrors.campGeoLon.value}"
            )
              .form-elem__title Долгота
              .form-elem__body
                input.input.input_full(
                v-model="fields.campGeoLon"
                @input="resetError('campGeoLon')"
                ref="campGeoLon"
                )
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Текстовое описание
      .profile-section__body
        .form
          .form__elem.form__elem_full
            .form-elem
              vue-editor.custom-editor(
              :editorToolbar="customToolbar"
              v-model="fields.campDesc"
              )
              //textarea.textarea.textarea_full.manager-camp__camp-desc(
              //v-model="fields.campDesc"
              //)
          .form__elem.form__elem_full
            .form-elem.form-elem_horizontal
              .form-elem__title Ссылка на видео
              .form-elem__body
                input.input.input_full(
                maxlength="128"
                v-model="fields.campVideo"
                )
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Фотографии базы отдыха
      .profile-section__body
        .form
          .form__elem.form__elem_full
            upload-photo-2(
            :photos="fields.campPhotos"
            @on-change="onChangeCampPhotos"
            )
    section.profile-page-form__section.profile-section
      .profile-section__body
        .form
          .form__elem.form__elem_button
            .form-elem(
              v-if="campData"
            )
              .form-elem__body
                router-link.button.button_long(
                :to="{name: 'CurrentCamp', params: {campId: campData.id}}"
                target="_blank"
                )
                  .button__text Просмотр
            .form-elem
              .form-elem__body
                button.button.button_paint-main.button_long(
                @click.prevent="onSaveCamp()"
                )
                  .button__text Сохранить
              .form-elem__error(
              v-if="currentErrorMessage.length > 0"
              ) {{currentErrorMessage}}

</template>

<script>
//todo обновить селекты и подтягивать районы с бэка
import {mapState} from "vuex";
import SimpleSelectForm from "../../../../../components/simpleSelectForm/SimpleSelectForm";
import UploadPhoto2 from "../../../../../components/uploadPhoto2/UploadPhoto2";
import Inputmask from "inputmask";
import {VueEditor} from "vue2-editor";

export default {
  name: "ManagerCampEditorAbout",
  components: {
    UploadPhoto2,
    SimpleSelectForm,
    Inputmask,
    VueEditor
  },
  props: {
    campData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      customToolbar: [
        [{size: ["small", false, "large", "huge"]}],
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        ["link"]

      ],
      managersList: [],
      fields: {
        campName: "",
        campCapacity: "",
        campRegion: "Татарстан",
        campArea: "Казань",
        campType: {
          text: "Тип не указан",
          value: null
        },
        campDesc: "",
        campVideo: "",
        campPhotos: [],
        campGeoLat: "",
        campGeoLon: ""
      },
      fieldsErrors: {
        campName: {
          value: false,
          message: "Введите название лагеря"
        },
        campCapacity: {
          value: false,
          message: "Введите вместимость"
        },
        campRegion: {
          value: false,
          message: "Выберите регион"
        },
        campArea: {
          value: false,
          message: "Выберите район"
        },
        campType: {
          value: false,
          message: "Выберите тип лагеря"
        },
        campGeoLat: {
          value: false,
          message: "Введите координаты"
        },
        campGeoLon: {
          value: false,
          message: "Введите координаты"
        }
      },
      currentErrorMessage: "",
      capacityMask: new Inputmask("integer", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false,
        max: 32000
      }),
      geoMask: new Inputmask("numeric", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false
      })
    };
  },
  computed: {
    ...mapState(["catalogue"]),
    campTypesListData: {
      get() {
        return JSON.parse(JSON.stringify(this.catalogue.campTypes));
      },
      set() {}
    },
    campRegionsListData: {
      get() {
        return JSON.parse(JSON.stringify(this.catalogue.regions));
      },
      set() {}
    },
    campAreasListData: {
      get() {
        return JSON.parse(JSON.stringify(this.catalogue.areas)).slice(1);
      },
      set() {}
    }

  },
  methods: {
    changeSelectValue(data, type) {
      this.fields[type] = data;
      if (type === "campRegion" && data === "Татарстан") {
        this.fields.campArea = this.campAreasListData[0];
      }
    },
    setCampType(type) {
      if (!type) {
        this.fields.campType = this.campTypesListData[0];
      } else {
        this.campTypesListData = this.campTypesListData.splice(0, 1);
        const index = this.campTypesListData.findIndex(item => {
          return item.value === type;
        });
        this.fields.campType = this.campTypesListData[index];
      }
    },
    setFields(campData) {
      this.fields.campName = campData.name;
      if (campData.capacity) {
        this.fields.campCapacity = campData.capacity;
      }

      if (campData.address && campData.address.region) {
        this.fields.campRegion = campData.address.region;
      }
      if (campData.address && campData.address.area) {
        this.fields.campArea = campData.address.area;
      }
      this.setCampType(campData.type);

      if (campData.geo_lat) {
        this.fields.campGeoLat = campData.geo_lat;
      }
      if (campData.geo_lon) {
        this.fields.campGeoLon = campData.geo_lon;
      }

      if (campData.description) {
        this.fields.campDesc = campData.description;
      }
      if (campData.video_link) {
        this.fields.campVideo = campData.video_link;
      }
      this.fields.campPhotos = campData.photos;
    },
    onChangeCampPhotos(photos) {
      this.fields.campPhotos = photos;
    },
    resetError(field) {
      this.fieldsErrors[field].value = false;
      this.currentErrorMessage = "";
    },
    validation() {
      const errors = [];
      const fieldsForLengthCheck = [
        "campName",
        "campCapacity",
        "campGeoLat",
        "campGeoLon"
      ];
      fieldsForLengthCheck.forEach((field) => {
        if (this.fields[field].length === 0) {
          errors.push(field);
        }
      });
      if (!this.fields.campType.value) {
        errors.push("campType");
      }

      if (errors.length > 0) {
        errors.forEach(err => {
          this.fieldsErrors[err].value = true;
        });
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },
    onSaveCamp() {
      if (!this.validation()) {
        return false;
      };

      if (this.fields.campRegion !== "Татарстан") {
        this.fields.campArea = "";
      }
      const data = {
        name: this.fields.campName,
        capacity: this.fields.campCapacity,
        address: {
          region: this.fields.campRegion,
          area: this.fields.campArea
        },
        type: this.fields.campType.value,
        geo_lat: this.fields.campGeoLat,
        geo_lon: this.fields.campGeoLon,
        description: this.fields.campDesc,
        video_link: this.fields.campVideo,
        photos: this.fields.campPhotos.map(item => {
          return item.id;
        })
      };
      this.$emit("on-save-camp", data);
    }
  },
  watch: {
    campData(val) {
      this.setFields(val);
    }
  },
  mounted() {
    this.capacityMask.mask(this.$refs.campCapacity);
    this.geoMask.mask(this.$refs.campGeoLat);
    this.geoMask.mask(this.$refs.campGeoLon);
    if (this.campData) {
      this.setFields(this.campData);
    }
  }
};
</script>
